import React from "react";
import { FormattedMessage, useIntl } from "react-intl";
import { Box } from "@mui/material";
import PropTypes from "prop-types";

import { CheckboxInput } from "../../common/form-controls";

import { SetUpPlanIntegrationButton, RunIntegrationButton } from "./integration-common.jsx";
import { Button } from "../../common/buttons";

const ActionsBox = ({
    checkedAll,
    onCheckedAllChange,
    onStartClick,
    onPlanClick,
    onManualIntegrationClick,
    isIntegrationPending,
    runIntegrationDisabled,
    allowManualIntegration = false,
}) => {
    const intl = useIntl();

    return (
        <Box className="integration-system-box-actions">
            <CheckboxInput
                label={intl.formatMessage({ id: "integration.actions-box.checkbox-choose-all" })}
                checked={checkedAll}
                disabled={isIntegrationPending}
                onChange={onCheckedAllChange}
            />

            <Box className="integration-system-box-actions-buttons">
                {allowManualIntegration && (
                    <Button variant="outlined" className="plan-integration-button" onClick={onManualIntegrationClick}>
                        <FormattedMessage id={"integration.actions-box.btn-manual-integration"} />
                    </Button>
                )}

                <SetUpPlanIntegrationButton onClick={() => onPlanClick("common")} />
                <RunIntegrationButton onClick={onStartClick} disabled={runIntegrationDisabled} />
            </Box>
        </Box>
    );
};

ActionsBox.propTypes = {
    checkedAll: PropTypes.bool,
    onCheckedAllChange: PropTypes.func,
    onStartClick: PropTypes.func,
    onDownloadClick: PropTypes.func,
    onPlanClick: PropTypes.func,
    isIntegrationPending: PropTypes.bool,
    runIntegrationDisabled: PropTypes.bool,
    allowManualIntegration: PropTypes.bool,
    onManualIntegrationClick: PropTypes.func,
};

export default ActionsBox;
